<template>
  <oct-dialog
    full
    :title="title"
    :align="align"
    icon="arrow-left"
    @dismiss="$_octPrototypeView_goBack"
    class="ss-salon-setting-view"
  >
    <!-- Content -->
    <oct-salon-setting-form
      :reservationUrl.sync="$data.$_ssSSV_reservationUrl"
      ref="$_ssSSV_form"
    />

    <!-- Actions -->
    <template #actions>
      <oct-button
        block
        size="large"
        :disabled="!$_ssSSV_hasChanged || processing"
        @click.native="submit"
      >
        保存
      </oct-button>
    </template>
  </oct-dialog>
</template>

<script>
import OctButton from '@/components/button/OctButton.vue'
import OctDialog from '@/components/dialog/OctDialog.vue'
import OctPrototypeView from '@/mixins/OctPrototypeView.js'
import OctSalonSettingForm from '@/components/salon-setting-form/OctSalonSettingForm.vue'

export default {
  name: 'SSSalonSettingView',
  mixins: [
    OctPrototypeView
  ],
  components: {
    OctButton,
    OctDialog,
    OctSalonSettingForm
  },
  props: {
    /** Page title */
    title: {
      type: String,
      default: '各種設定'
    },
    /** Dialog alignment */
    align: {
      type: String,
      default: 'left'
    },
  },
  data: () => ({
    /** Reservation URL */
    $_ssSSV_reservationUrl: '' ,
  }),
  computed: {
    /** Indicate validity of the form */
    $_ssSSV_hasChanged () {
      return this.$data.$_ssSSV_reservationUrl !== this.$store.state.reservationUrl
    }
  },
  methods: {
    /** Submit data */
    async submit () {
      if (!this.$refs.$_ssSSV_form.validate()) return

      this.processing = true

      try {
        // Save salon
        await this.$store.dispatch('save', {
          reservationUrl: this.$data.$_ssSSV_reservationUrl || null
        })

        // Notify
        this.$store.dispatch('notify', {
          text: 'URLを登録しました'
        })

        // Go back
        this.$_octPrototypeView_goBack()
      } catch (error) {
        this.$store.dispatch('alert', '保存できませんでした')
      } finally {
        this.processing = false
      }
    },
  },
  mounted () {
    // Initialize reservation URL
    this.$data.$_ssSSV_reservationUrl = this.$store.state.reservationUrl
  }
}
</script>

<style scoped lang="scss">
@import "../components/theme/variables";
@import "../components/grid/variables";
@import "../components/typography/variables";
@import "../components/typography/mixins";

.ss-salon-setting-view {
  &::v-deep .oct-dialog-header {
    margin-bottom: oct-rem(32);
  }
}
</style>